import { SkeletonPage } from "@shopify/polaris";

/**
 * Loading placeholder for the work security role detail page. Mirrors the real
 * layout — the active security rules card (wide) and assigned workers card
 * (narrow) side by side, plus the full-width documents card — so the page
 * doesn't jump once the role loads, instead of a bare spinner.
 */
export default function WorkSecurityViewSkeleton() {
  return (
    <SkeletonPage fullWidth backAction>
      <div
        className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3 animate-pulse"
        aria-hidden="true"
      >
        {/* rules card */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
            <div className="h-4 w-44 bg-gray-200 rounded mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="h-12 bg-gray-100 rounded-lg" />
              ))}
            </div>
          </div>
        </div>
        {/* assigned workers card */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6">
            <div className="h-4 w-32 bg-gray-200 rounded mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="h-8 bg-gray-100 rounded" />
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* documents card */}
      <div
        className="mt-6 bg-white rounded-xl shadow-sm border border-zinc-200 p-6 animate-pulse"
        aria-hidden="true"
      >
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" />
        <div className="space-y-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="h-24 bg-gray-100 rounded-lg" />
          ))}
        </div>
      </div>
    </SkeletonPage>
  );
}
